module.exports = __webpack_public_path__ + "static/media/spring-new.93abf625.png";